/**
 * Moves Get in touch socials to last container of left column (blue box)
 */
export class GetInTouchSocials {
    constructor() {
        const socialIcons = document.querySelector(
            ".get-in-touch [data-socials]"
        );
        if (!socialIcons) {
            return;
        }
        const container = document.querySelector(
            ".get-in-touch .container:last-of-type"
        );
        if (!container) {
            return;
        }
        const icons = socialIcons.cloneNode(true);
        socialIcons.remove();
        icons.classList.remove("hidden");
        container.prepend(icons);
    }
}
